import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Util from '../../helper/Util';
import { Translate } from '../../localization';
import SortIcon from '@mui/icons-material/Sort';
import { MenuItem, Menu } from '@material-ui/core';
import { getDeviceLocation, setLanguage, getTenentStatus } from '../../store/actions/general.actions';
import { setLocationsActive, setPrematchActive } from '../../store/actions/prematchActions';
import Login from '../Login';
import SignUp from '../SignUp';
import MyAccount from '../MyAccount';
import { Link } from 'react-router-dom';
import MenuBar from './MenuBar';
import { META_LOGIN_TIME } from '../../config';
import CasinoSearch from '../Casino/CasinoSearch';

const options = ['en-US', 'zh-CN', 'zh-TW', 'th', 'ko']
const optionToDisplay = {
    'en-US':'English',
    'zh-CN':'简体中文',
    'zh-TW':'繁體中文',
    'th':'ภาษาไทย',
    'ko':'한국어',
}
let metaInterval;

function convertLangCode(langCode) {
    return langCode.replace('-', '_');
}
function detectLanguage(lang) {
    let langValue = options.includes(lang) ? true : false
    if (langValue === true) {
        return options.indexOf(lang)
    } else {
        return 0
    }
}
function replaceLanguageCode(path, newLanguageCode) {
    // const regex = /^\/([a-z]{2}-[A-Z]{2})\//;
    const regex = /^\/([a-z]{2}(?:_[A-Z]{2})?)\//;
    return path.replace(regex, `/${newLanguageCode}/`);
}
class Header extends Component {
    constructor(props) {
        super(props);

        this.header = React.createRef();

        this.state = {
            anchorEl: null,
            selectedIndex: 0,
            showSignUp: false,
            showMyAccount: false,
            theme: '',
            ShowleftItems: true,
            showLogin: false,
            redirectLink: '',
            showMobileSidebar: false,
            metaMaskAccount: localStorage.getItem('accounts') ? Util.cryptoJsDecryption(localStorage.getItem('accounts')) : [],
            metaLoginTime: localStorage.getItem('metaLoginTime') ? JSON.parse(localStorage.getItem('metaLoginTime')) : '',
            metaMaskBalance: null,
        };
    }

    componentDidMount() {
        this.checkMetaLogin();

        let currentPath = this.props.location.pathname;
        let pathIndex = currentPath.split('/');
        if (pathIndex[2] === 'live-casino' || pathIndex[2] === 'casino' || pathIndex[2] === 'virtual-sports') {
            this.setState({
                ShowleftItems: false,
            });
        }

        const getLan = localStorage.getItem('language');
        let userSelectedLang = getLan?.length > 0 ? getLan : navigator.language
        let userSelectedLangIndex = detectLanguage(userSelectedLang)
        this.props.getTenentStatus();
        this.props.getDeviceLocation();
        if (userSelectedLangIndex !== this.state.selectedIndex) {
            localStorage.setItem('language', userSelectedLang);
            this.props.setLanguage(Translate.getLanguage());
            Translate.setLanguage(userSelectedLang);
            this.setState({
                selectedIndex: userSelectedLangIndex,
            });
        }

        window.addEventListener('scroll', this.toggleHeader, false);
        if (!localStorage.getItem('theme')) {
            document.body.classList.remove('dark-mode');
            localStorage.setItem('theme', 'light-mode');
            this.setState({ theme: 'light-mode' });
        } else if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark-mode') {
            document.body.classList.add('dark-mode');
            this.setState({ theme: 'dark-mode' });
        }

        // if(this.props.location.pathname === '/d/promotion')
        // {
        //     sessionStorage.setItem('isPromotionActive', true);
        // }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.country !== this.props.country && this.props.country === 'NL' && !localStorage.getItem('language')) {
            Translate.setLanguage('nl');
            let userSelectedLangIndex = options.indexOf('nl');
            this.changeLanguage(null, userSelectedLangIndex);
            this.setState({
                selectedIndex: userSelectedLangIndex,
            });
        }

        if (localStorage.getItem('agentCode') && !this.state.showSignUp && !this.isLoggedIn() && localStorage.getItem('firstAgentCodeHit') === 'true') {
            this.showSignUpForm();
            localStorage.setItem('firstAgentCodeHit', false); //To allow closing of signup form
        }
    }

    componentWillUnmount() {
        if (this.header.current) this.header.current.classList.remove('header_dark');
        const lastUrl = localStorage.getItem('lastUrl');
        localStorage.setItem('lastUrl', this.props.location.pathname);
        localStorage.setItem('secondLastUrl', lastUrl);
        window.removeEventListener('scroll', this.toggleHeader, false);
        localStorage.setItem('LastUrl', this.props.location.pathname);
    }

    toggleHeader = () => {
        if (this.props.headerClassname === 'header_transparent') {
            if (window.pageYOffset > this.header.current.clientHeight) {
                this.header.current.classList.add('header_dark');
            } else {
                this.header.current.classList.remove('header_dark');
            }
        }
    };

    handleClickMenu = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    };

    changeLanguage = (event, index) => {
        let language = options[index];
        // FIXME: For the temp work we will be sending fr as code for Portuguese language (pt)
        // if  (language == 'pt') language = 'fr';
        Translate.setLanguage(language);
        this.props.setLanguage(Translate.getLanguage());
        localStorage.setItem('language', language);

        this.setState({
            anchorEl: null,
            selectedIndex: index,
        });
        const currentPath = this.props.location.pathname;
        const newPath = replaceLanguageCode(currentPath, language)
        this.props.history.push(newPath);
    };

    // changeLanguageMobile = (event) => {
    //     let index = parseInt(event.target.value);
    //     let language = options[index];
    //     // FIXME: For the temp work we will be sending fr as code for Portuguese language (pt)
    //     //if  (language == 'pt') language = 'fr';
    //     Translate.setLanguage(language);
    //     this.props.setLanguage(Translate.getLanguage());
    //     localStorage.setItem('language', language);

    //     this.setState({
    //         selectedIndex: index,
    //     });
    // };

    handleCloseMenu = () => {
        this.setState({
            anchorEl: null,
        });
    };

    showLoginForm = (path) => {
        if (Util.isLoggedIn()) {
            this.setState({ showLogin: false });
            this.props.history.push(path);
        } else {
            this.setState({
                showLogin: true,
                redirectLink: path,
            });
        }
    };

    hideLogin = () => {
        if (Util.isLoggedIn()) {
            this.setState({ showLogin: false });
            this.props.history.push(this.state.redirectLink);
        } else {
            this.setState({ showLogin: false });
        }
    };

    showSignUpForm = (e) => {
        this.setState({ showSignUp: true });
    };

    hideSignUp = () => {
        this.setState({ showSignUp: false });
    };

    isLoggedIn = () => {
        const { access_token } = Util.getAccessToken();
        const isUserLoggedIn = Util.isAuthTokenValid(access_token);
        return isUserLoggedIn;
    };

    handleToggle = () => {
        if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark-mode') {
            localStorage.setItem('theme', 'light-mode');
            document.body.classList.remove('dark-mode');
            this.setState({ theme: 'light-mode' });
        } else if (localStorage.getItem('theme') && localStorage.getItem('theme') === 'light-mode') {
            localStorage.setItem('theme', 'dark-mode');
            document.body.classList.add('dark-mode');
            this.setState({ theme: 'dark-mode' });
        } else {
            localStorage.setItem('theme', 'light-mode');
            document.body.classList.remove('dark-mode');
            this.setState({ theme: 'light-mode' });
        }
    };

    reqMetaMaskAccount = async () => {
        // MetaMask will inject ethereum object in webpage.
        const { ethereum } = window;
        if (!ethereum) {
            // in case ethereum is not available
            toastr.error('', 'Please install the metaMask extension and refresh the page.');
            setTimeout(() => {
                window.open('https://metamask.io/');
            }, 2000);
        } else {
            // ethereum is available
            try {
                const accounts = await ethereum.request({ method: 'eth_requestAccounts' }); // will get all accounts
                if (accounts.length > 0) {
                    let params = [accounts[0], 'latest']; // params for get balance
                    let balance = await ethereum.request({ method: 'eth_getBalance', params });
                    let EthBal = parseInt(balance, 16);
                    EthBal = EthBal * Math.pow(10, -18);
                    const encryptedAccount = Util.cryptoJsEncryption(accounts);
                    this.setState({ metaMaskAccount: accounts, metaMaskBalance: EthBal });
                    localStorage.setItem('accounts', encryptedAccount);
                    localStorage.setItem('metaLoginTime', JSON.stringify(new Date().getTime()));
                    metaInterval = setInterval(() => {
                        this.checkMetaLogin(true);
                    }, META_LOGIN_TIME + 500);
                } else {
                    toastr.error('', 'Request denied, please try again');
                }
            } catch (err) {
                toastr.error('', err?.message);
            }
        }
    };
    checkMetaLogin = (sessionExpired) => {
        const { metaMaskAccount, metaLoginTime } = this.state;
        const { ethereum } = window;
        if (metaMaskAccount?.length && metaLoginTime + META_LOGIN_TIME > new Date().getTime()) {
            try {
                let params = [metaMaskAccount[0], 'latest']; // params for get balance
                ethereum.request({ method: 'eth_getBalance', params }).then((balance) => {
                    let EthBal = parseInt(balance, 16);
                    EthBal = EthBal * Math.pow(10, -18);
                    this.setState({ metaMaskBalance: EthBal });
                });
            } catch (err) {
                this.signOutMetaMask(false);
            }
        } else {
            this.signOutMetaMask(false, sessionExpired);
        }
    };

    signOutMetaMask = async (showSuccess = true, sessionExpired = false) => {
        // localStorage.setItem('metaMaskLoggedIn', false)
        // const { ethereum } = window;
        // const accounts = await ethereum.request({ method: 'disconnect'})
        if (showSuccess) toastr.success('', 'Sign out successfully');
        else if (sessionExpired) toastr.error('', 'Session expired please login again.');
        localStorage.removeItem('accounts');
        localStorage.removeItem('metaLoginTime');
        this.setState({ metaMaskAccount: [], metaMaskBalance: null, metaLoginTime: '' });
        clearInterval(metaInterval);
    };

    render() {
        let { anchorEl, selectedIndex, showSignUp, showMyAccount, showMobileSidebar, metaMaskBalance } = this.state;
        let { userData } = this.props;
        let currency = userData && userData.currency ? (userData.currency === 'EUR' ? 'USD' : userData.currency) : 'USD';
        let isMetaMask = metaMaskBalance != null;
        const languageList = options.map((option, index) => (
            <MenuItem key={option} selected={index === selectedIndex} onClick={(event) => this.changeLanguage(event, index)} className="text-uppercase">
                {optionToDisplay[option]}
            </MenuItem>
        ));

        let liveCasinoClass = '';
        let casinoClass = '';

        if (userData) {
            liveCasinoClass = userData.is_live_casino_enabled ? '' : 'disabled';
            casinoClass = userData.is_casino_enabled ? '' : 'disabled';
        }

        let extraMarketPre = this.props.location.pathname?.includes('/extra-market');
        let extraMarketLive = this.props.location.pathname?.includes('live-bettingextra-market');
        let showSearch = ['casino', 'live-casino'].indexOf(this.props.location.pathname?.split('/')[2]) >= 0 ? true : false;
        return (
            <Fragment>
                <header id="myHeader" className='d-flex align-items-center'>
                    <div className='container d-flex justify-content-between align-items-center'>
                        <div className="d-flex align-items-center">
                            <div className="toggle-icon mr-2 d-block d-xl-none">
                                <a onClick={() => this.setState({ showMobileSidebar: true })}>
                                    <SortIcon style={{ color: '#FFFFFF' }} />
                                </a>
                            </div>
                            <div className="logo d-flex">
                                <a href={`/${Translate.getLanguage()}/d/casino`}>
                                    <img src="/images/sports/logo.png" />
                                </a>
                            </div>
                        </div>
                        <ul className=" menu d-xl-flex flex-grow-1 d-none">
                            {
                                <li className={`${this.props.location.pathname === `/${Translate.getLanguage()}/d/casino` && 'active'} ${casinoClass}`}>
                                    <Link to={`/${Translate.getLanguage()}/d/casino`}>{Translate.casino}</Link>
                                </li>
                            }
                            {
                                <li className={`${this.props.location.pathname === `/${Translate.getLanguage()}/d/live-casino` && 'active'} ${liveCasinoClass}`}>
                                    <Link to={`/${Translate.getLanguage()}/d/live-casino`}>{Translate.liveCasino}</Link>
                                </li>
                            }
                            <li className={`${this.props.location.pathname?.includes(`/${Translate.getLanguage()}/d/promotion`) && 'active'} `}>
                                <Link to={`/${Translate.getLanguage()}/d/promotion`}>{Translate.promotion}</Link>
                            </li>

                        </ul>
                        <div className="head-right d-flex align-items-center">
                            <div className="casino-search-desktop">
                                <CasinoSearch />
                            </div>
                            {this.isLoggedIn() || isMetaMask ? (
                                <React.Fragment>
                                    {isMetaMask ? (
                                        <>
                                            <div className="user-detail">
                                                <div className="d-flex align-items-center">
                                                    <div className="user-p">
                                                        <span>
                                                            <i className="icon-my-account"></i>
                                                        </span>
                                                    </div>
                                                    <p>
                                                        <span>
                                                            {Translate.walletBalance}: {metaMaskBalance}{' '}
                                                        </span>
                                                    </p>
                                                    <button className="btn btn-primary mr-2" onClick={this.signOutMetaMask}>
                                                        {Translate.logout}
                                                    </button>
                                                </div>
                                            </div>
                                            {/* <button className="btn-in-header"><span>Wallet Bal: { metaMaskBalance } </span></button>
                                        <button className="btn-in-header" onClick={this.signOutMetaMask}>
                                            {Translate.logout}
                                        </button> */}
                                        </>
                                    ) : (
                                        <>
                                            <Link className="mobile-menu" to={`/${Translate.getLanguage()}/d/my-account`}>
                                                <span>{userData ? `${Util.toFixedDecimal(userData.balance)}` : 'Loading...'}</span>

                                                <span className="currency-text">{currency}</span>
                                            </Link>
                                            <div className="desktop-menu">
                                                <div className="user-detail">
                                                    <div className="d-flex align-items-center">
                                                        <div className="user-p">
                                                            <span>
                                                                <i className="icon-my-account"></i>
                                                            </span>
                                                        </div>
                                                        <p>
                                                            {userData?.username}
                                                            <span>
                                                                {' '}
                                                                {userData ? `${Util.toFixedDecimal(userData.balance)} ${currency}` : `Loading... ${currency}`}{' '}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="btn-group d-flex align-items-center">
                                                    <button onClick={() => this.setState({ showMyAccount: true })}>{Translate.myAccount}</button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </React.Fragment>
                            ) : (
                                <Fragment>
                                    {/* <button className='btn btn-secondary my-2 ml-3' onClick={this.reqMetaMaskAccount}>{Translate.metaMaskLogin}</button> */}
                                    <button type="button" className="btn btn-secondary btn-sign-up my-2 ml-3" onClick={this.showLoginForm}>
                                        {Translate.login}
                                    </button>
                                    <button type="button" className="btn btn-primary btn-login my-2 ml-3" onClick={this.showSignUpForm}>
                                        {' '}
                                        {Translate.signup}
                                    </button>
                                </Fragment>
                            )}
                            <div className="btn-group ">
                                <div className="dropdown country-btn">
                                    <a
                                        aria-haspopup="true"
                                        aria-controls="language-menu"
                                        className="btn language-select__selected text-uppercase"
                                        onClick={this.handleClickMenu}
                                        role="button"
                                        href="javascript:void(0)"
                                    >
                                        {optionToDisplay[options[selectedIndex < 0 ? 0 : selectedIndex]]}
                                    </a>
                                    <Menu
                                        id="language-menu"
                                        style={{ height: '300px', overflowY: 'auto' }}
                                        className="dropdown-menu show"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={this.handleCloseMenu}
                                    >
                                        {languageList}
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showMyAccount && <MyAccount onClose={() => this.setState({ showMyAccount: false })} />}
                </header >

                {showMobileSidebar && (
                    <MenuBar
                        hideMenuBar={() => this.setState({ showMobileSidebar: false })}
                        showMobileSidebar={showMobileSidebar}
                        showLoginForm={this.showLoginForm}
                        showSignUpForm={this.showSignUpForm}
                        isLoggedIn={this.isLoggedIn()}
                    />
                )
                }
                {showSignUp && <SignUp hideSignUp={this.hideSignUp} />}
                {this.state.showLogin && <Login hideLogin={this.hideLogin} />}
            </Fragment >
        );
    }
}

Header.propTypes = {
    userData: PropTypes.object,
    setLanguage: PropTypes.func,
    language: PropTypes.string,
    headerClassname: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        language: state.general.language,
        country: state.general.country,
        isShowCasino: state.general.isShowCasino,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setLanguage: (value) => dispatch(setLanguage(value)),
        setLocationsActive: (value) => dispatch(setLocationsActive(value)),
        setPrematchActive: (value) => dispatch(setPrematchActive(value)),
        getDeviceLocation: () => dispatch(getDeviceLocation()),
        getTenentStatus: () => dispatch(getTenentStatus()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
